export const ACCEPT_ETK_START = 'ACCEPT_ETK_START';
export const ACCEPT_ETK_SUCCESS = 'ACCEPT_ETK_SUCCESS';
export const ACCEPT_ETK_FAIL = 'ACCEPT_ETK_FAIL';
export const ACCEPT_ETK_RESET = 'ACCEPT_ETK_RESET';
